import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ItemTypeClassesActions } from './item-type-classes.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import { AsyncActions } from './item-type-classes.actions';
import {ItemTypeClass} from '@emm/core/models/item-type-class.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const itemTypeClassesFeatureKey = 'itemTypeClasses';

export interface ItemTypeClassesState extends EntityState<ItemTypeClass>, AsyncActionState {}

export const adapter: EntityAdapter<ItemTypeClass> = createEntityAdapter<ItemTypeClass>({
    selectId: (item: ItemTypeClass) => item.classTag,
    sortComparer: null
});

export const initialState: ItemTypeClassesState = adapter.getInitialState({
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const itemTypeClassesReducer = withLoadables<ItemTypeClassesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,
    on(ManagementBaseActions.initItemTypes, () => ({
        ...initialState
    })),
    on(ItemTypeClassesActions.loadSuccess, (state: ItemTypeClassesState, { itemTypeClasses }) =>
        adapter.setAll(itemTypeClasses, state)
    )
);
